var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWbeth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    transform: "rotate(90 100 100)",
    fill: "url(#paint0_linear_6129_25416)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4156 37.7324C18.0794 54.1193 8.69043 76.141 8.69043 100.356C8.69043 123.418 17.2073 144.492 31.2675 160.602L37.1941 154.675C24.7701 140.121 17.2692 121.237 17.2692 100.601C17.2692 78.6874 25.7273 58.7496 39.557 43.8739L33.4156 37.7324ZM157.329 161.646C142.454 175.476 122.516 183.934 100.603 183.934C78.9675 183.934 59.2581 175.689 44.4448 162.17L38.557 168.058C54.8547 182.943 76.5456 192.022 100.357 192.022C124.572 192.022 146.593 182.633 162.98 167.297L157.329 161.646ZM170.18 159.751L164.512 154.083C176.636 139.61 183.936 120.958 183.936 100.601C183.936 78.9656 175.691 59.2562 162.172 44.4429L168.06 38.5556C182.945 54.8532 192.024 76.5441 192.024 100.356C192.024 123.014 183.802 143.753 170.18 159.751ZM47.1202 36.6914L40.9614 30.5326C56.9596 16.9102 77.6983 8.68896 100.357 8.68896C123.42 8.68896 144.493 17.2059 160.604 31.266L154.677 37.1923C140.123 24.7683 121.239 17.2674 100.603 17.2674C80.2453 17.2674 61.593 24.5669 47.1202 36.6914Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9013 41.707V84.5775L64.2996 100.747L99.9013 41.707Z",
    fill: "#868686"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9014 84.5762V121.81L64.2997 100.745L99.9014 84.5762Z",
    fill: "#363636"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9014 129.212V158.138L64.2997 108.148L99.9014 129.212Z",
    fill: "#868686"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9006 41.7067V84.5771L135.502 100.746L99.9006 41.7067Z",
    fill: "#312706"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9006 84.5762V121.81L135.502 100.745L99.9006 84.5762Z",
    fill: "#130F03"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9006 129.212V158.138L135.502 108.148L99.9006 129.212Z",
    fill: "#312807"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6129_25416",
    x1: 100,
    y1: -0.00000762939,
    x2: 100,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbeth);
export default __webpack_public_path__ + "static/media/wbeth.9e0d4c01bf7856073930b64798b7ebde.svg";
export { ForwardRef as ReactComponent };